import { _t } from '@bark/bark-core';

export default function ResubmitBarkPage() {
	const { Bark } = window;

	/**

     * Flag to say whether submitting or not

     * @type Boolean

     */

	var submitting = false;

	var enforceCharacterCount = true;

	/**

     * Flag to say whether submitting or not

     * @type Boolean

     */

	var instantResubmit = false;

	var consts = {
		/**

         * The minimum number of characters in additional details required for resubmission

         */

		MIN_DETAIL_LENGTH: 50,
	};

	/**

     * Update the character count in the additional details textarea

     */

	function updateCount() {
		var t = $('.bark-dash.resubmit-barks .buyer-barks textarea');

		var countdown = $('.n-chars-remaining');

		var remaining = consts.MIN_DETAIL_LENGTH - t[0].value.trim().length;

		var submit = $('.bark-dash.resubmit-barks .submit-container button');

		if (remaining > 0 && enforceCharacterCount) {
			// The user hasn't typed enough

			countdown.text(
			    _t("buyer_resubmit-bark:characters-remaining", {count: remaining})
			);

			countdown.css({ display: 'block' }).finish().animate({ opacity: 1 }, 400);

			submit.addClass('disabled');
		} else {
			// The user has typed enough

			countdown.finish().animate({ opacity: 0 }, 400, 'swing', function () {
				countdown.hide();
			});

			submit.removeClass('disabled');
		}
	}

	function submitWhenReady(callback) {
		var restartCounter = 10;

		var timerFunction = function () {
			if (restartCounter <= 0) {
				callback();
			} else {
				restartCounter--;

				Bark.json({
					url: '/api/tsugdne/',

					data: {
						preBarkId: $('#pre-bark-id').val(),
					},
				})
					.done(function (r) {
						if (r && r.success) {
							callback();
						} else {
							setTimeout(timerFunction, 500);
						}
					})
					.fail(function () {
						setTimeout(timerFunction, 500);
					});
			}
		};

		timerFunction();
	}

	function showUI() {
		$('.resubmit-barks').removeClass('instant-resubmit');
	}

	function submitProject() {
		var payload = { fileIds: [], imageIds: [] };

		var phoneInDetail;

		if (submitting || $(this).hasClass('disabled')) {
			Bark.hideLoading();

			return;
		}

		$('.modal-uploader-hidden-input').each(function () {
			var key = $(this).data('type') + 'Ids';

			payload[key].push(this.value);
		});

		payload.detail = $('.bark-dash.resubmit-barks .buyer-barks textarea').val().trim();

		payload.id = $('#project-id').val();

		payload.preBarkId = $('#pre-bark-id').val();

		// Remove date first, then remove all non-alnum chars, and then match a sequence of numbers of at least 6 characters and at most 14

		phoneInDetail = payload.detail
			.replace(/\d{1,2}[\s\.\-\/]+\d{1,2}[\s\.\-\/]+\d{2,4}/gi, '')
			.replace(/[^A-Za-z0-9]/gi, '')
			.match(/[0-9]{6,14}/);

		if (phoneInDetail) {
			alert(
                _t("buyer_resubmit-bark:phone-number-error", {formatted_telephone_number: phoneInDetail[0]})
			);

			Bark.hideLoading();

			showUI();

			return;
		}

		if (!instantResubmit) {
			if (payload.detail.length < consts.MIN_DETAIL_LENGTH && enforceCharacterCount) {
				updateCount();

				return;
			}

			Bark.showLoading();
		}

		submitting = true;

        if (document.getElementsByName('nrfTrustedFormToken')[0]) {
            const tformtoken = document.getElementsByName('nrfTrustedFormToken')[0];
            payload.tform_token = String(tformtoken.getAttribute('value'));
        }

		submitWhenReady(function () {
			// Use Bark.json as it has CSRF built in

			Bark.json({
				url: '/buyers/post-resubmit/',

				data: { payload: JSON.stringify(payload) },
			})
				.done(function (e) {
					if (e.result === 'OK') {
						document.location = e.url;

						return;
					}

					alert(e.result);

					showUI();

					submitting = false;

					Bark.hideLoading();
				})
				.fail(function () {
					alert(_t("buyer_resubmit-bark:failed-error"));
					showUI();
					submitting = false;
				});
		});
	}

	const init = () => {
		Bark.initModalUpload();

		$('.bark-dash.resubmit-barks .submit-container button')
			.unbind('click.submit')
			.on('click.submit', submitProject);

		$('.bark-dash.resubmit-barks .buyer-barks textarea')
			.unbind('keyup.count')
			.on('keyup.count', updateCount);

		$('.resubmit-barks').each(function (i, e) {
			if ($(e).hasClass('instant-resubmit')) {
				Bark.showLoading();

				instantResubmit = true;

				setTimeout(submitProject, 500);
			}
		});

		if ($('.n-chars-remaining').hasClass('ignore-char-count')) {
			enforceCharacterCount = false;
		}

		updateCount();
	};

	init();
}
